type ScoredCompany = {
  risk_score?: number | string | null;
  businessIntelligence?: { riskScore?: number | string | null } | null;
} | null | undefined;

const toNumber = (v: number | string | null | undefined): number | null => {
  if (v === null || v === undefined || v === '') return null;
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(n) ? n : null;
};

/**
 * A portfolio client's risk score (the CRS), or null when nothing was measured.
 * Never `|| 0`: 0 is the lowest risk, and an absent score must read "Not measured".
 */
export function measuredRiskScore(company: ScoredCompany): number | null {
  if (!company) return null;
  return toNumber(company.risk_score) ?? toNumber(company.businessIntelligence?.riskScore);
}
